import { render, staticRenderFns } from "./AddVendorProduct.vue?vue&type=template&id=9d71a728&scoped=true&"
import script from "./AddVendorProduct.vue?vue&type=script&lang=js&"
export * from "./AddVendorProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddVendorProduct.vue?vue&type=style&index=0&id=9d71a728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d71a728",
  null
  
)

component.options.__file = "AddVendorProduct.vue"
export default component.exports